import {
    HierarchyPath,
    TreeNode,
    checkSpecificHierarchy,
} from "../../../../../components/TreeCheckboxGroup";
import { DraftPlaylist, PlaylistStatus } from "../../type";
import { ResourcePath } from "../utils";

export const initialState: (userId: string) => DraftPlaylist = (userId) => ({
    author_id: userId,
    status: { status: PlaylistStatus.DRAFT },
    learning_items: [],
    description: "",
    dirty: false,
});

export type PlaylistAction =
    | { type: "update_name"; name: string }
    | { type: "update_description"; description: string }
    | {
          type: "check_learning_item";
          learning_item: HierarchyPath;
          resources: Record<string, TreeNode>;
      }
    | {
          type: "change_resources_order";
          resources: ResourcePath[];
      }
    | {
          type: "set_playlist";
          playlist: DraftPlaylist;
      };

const playlistReducer = (
    state: DraftPlaylist | undefined,
    action: PlaylistAction
): DraftPlaylist | undefined => {
    const type = action.type;

    if (type === "set_playlist") return action.playlist;

    if (typeof state === "undefined")
        throw new Error("Cannot dispatch actions to uninitialized playlist");

    switch (type) {
        case "update_name": {
            return {
                ...state,
                name: action.name,
                dirty: true,
            };
        }
        case "update_description": {
            return {
                ...state,
                description: action.description,
                dirty: true,
            };
        }
        case "check_learning_item": {
            const newLearningItems = checkSpecificHierarchy(
                action.learning_item,
                state.learning_items.map((item) => item.toEditorPath()),
                action.resources
            );
            return {
                ...state,
                learning_items: newLearningItems.map((path) =>
                    ResourcePath.fromEditorPath(path)
                ),
                dirty: true,
            };
        }
        case "change_resources_order": {
            return {
                ...state,
                learning_items: action.resources,
                dirty: true,
            };
        }
        default: {
            const _: never = type;
            return state;
        }
    }
};
export default playlistReducer;
